import React, { useState } from 'react';
import '../AiArtifacts/artifact.css';
import { Link } from 'react-router-dom';

import poster1 from '../AiArtifacts/Artifacts_Image/temple1.png';
import poster2 from '../AiArtifacts/Artifacts_Image/jagannath.png';
import poster3 from '../AiArtifacts/Artifacts_Image/multiverse.png';
import poster4 from '../AiArtifacts/Artifacts_Image/hell.png';
import poster5 from '../AiArtifacts/Artifacts_Image/heaven.png';
import poster6 from '../AiArtifacts/Artifacts_Image/kaliyuga.png';
import poster7 from '../AiArtifacts/Artifacts_Image/sanatandharmayoga.png';
import poster8 from '../AiArtifacts/Artifacts_Image/inclusiveEbook.png';
import poster9 from '../AiArtifacts/Artifacts_Image/sanatanallinclusive.png';
import poster10 from '../AiArtifacts/Artifacts_Image/possession.png';
import poster11 from '../AiArtifacts/Artifacts_Image/vasudev.png';
import poster12 from '../AiArtifacts/Artifacts_Image/indianculture.png';
import poster13 from '../AiArtifacts/Artifacts_Image/shivashakti.png';
import poster14 from '../AiArtifacts/Artifacts_Image/interfaithcube.png';
import poster15 from '../AiArtifacts/Artifacts_Image/allinclusive.png';
import poster16 from '../AiArtifacts/Artifacts_Image/rebirth.png';
import poster17 from '../AiArtifacts/Artifacts_Image/positivevsnegativesoul.png';
import poster18 from '../AiArtifacts/Artifacts_Image/panorama.png';
import poster19 from '../AiArtifacts/Artifacts_Image/aidharma.png';
import poster20 from '../AiArtifacts/Artifacts_Image/sanatanjourney.png';

function AiArtifacts() {
  const [selectedArtifact, setSelectedArtifact] = useState(null);

  const artifacts = [
    {
      id: 1,
      title: 'Temple1',
      views: 10,
      status: 'Public',
      image: poster1,
      iframeSrc: 'https://3dthis.com/play.htm?h=NTg5MjE2MQ',
    },
    {
      id: 2,
      title: 'Jagannath Rath',
      views: 5,
      status: 'Public',
      image: poster2, 
      // iframeSrc: 'https://3dthis.com/play.htm?h=Nzg3ODU5NQ',
      iframeSrc: 'https://3dthis.com/play.htm?h=Nzg3ODU5NQ',
    },
    {
      id: 3,
      title: 'Multiverse',
      views: 15,
      status: 'Public',
      image: poster3, 
      // iframeSrc: 'http://player.3dthis.com?LTM4MjcyOTg',
      iframeSrc: 'https://3dthis.com/share.htm?h=LTM4MjcyOTg',
    },
     {
      id: 4,
      title: 'Hell',
      views: 10,
      status: 'Public',
      image: poster4,
      // iframeSrc: 'http://player.3dthis.com?OTEyODI2NQ',
      iframeSrc: 'https://3dthis.com/share.htm?h=OTEyODI2NQ',
    },
    {
      id: 5,
      title: 'Heaven',
      views: 5,
      status: 'Public',
      image: poster5, 
      iframeSrc: 'https://3dthis.com/share.htm?h=LTY3ODU1MzE',
    },
    {
      id: 6,
      title: 'Kaliyuga',
      views: 15,
      status: 'Public',
      image: poster6, 
      iframeSrc: 'https://3dthis.com/share.htm?h=LTQ2MTczOTE',
    },
     {
      id: 7,
      title: 'Sanatan Dharma Yoga',
      views: 10,
      status: 'Public',
      image: poster7,
      iframeSrc: 'https://3dthis.com/share.htm?h=LTkzODAyNjg',
    },
    {
      id: 8,
      title: 'Inclusive-EBOOK',
      views: 5,
      status: 'Public',
      image: poster8,
      iframeSrc: 'https://3dthis.com/share.htm?h=MjE4OTc4Ng',
    },
    {
      id: 9,
      title: 'Sanatan All Inclusive',
      views: 15,
      status: 'Public',
      image: poster9,
      iframeSrc: 'https://3dthis.com/share.htm?h=ODE5NDQyMA',
    },
     {
      id: 10,
      title: 'Possession',
      views: 10,
      status: 'Public',
      image: poster10,
      iframeSrc: 'https://3dthis.com/share.htm?h=LTEzNzkwNDE',
    },
    {
      id: 11,
      title: 'Vasudev Kutumb',
      views: 5,
      status: 'Public',
      image: poster11,
      iframeSrc: 'https://3dthis.com/share.htm?h=LTUxNTQyMjg',
    },
    {
      id: 12,
      title: 'Indian Culture',
      views: 15,
      status: 'Public',
      image: poster12, 
      iframeSrc: 'https://3dthis.com/share.htm?h=LTY4MDA3NQ',
    },
     {
      id: 13,
      title: 'Shiva-Shakti',
      views: 10,
      status: 'Public',
      image: poster13,
      iframeSrc: 'https://3dthis.com/share.htm?h=NDAyNzU0MQ',
    },
    {
      id: 14,
      title: 'Interfaith-Cube',
      views: 5,
      status: 'Public',
      image: poster14, // reuse same image for now
      iframeSrc: 'https://3dthis.com/share.htm?h=LTMxOTMwNzQ',
    },
    {
      id: 15,
      title: 'All Inclusive',
      views: 15,
      status: 'Public',
      image: poster15, // reuse same image
      iframeSrc: 'https://3dthis.com/share.htm?h=LTUzMDY4OTA',
    },
     {
      id: 16,
      title: 'ReBirth',
      views: 10,
      status: 'Public',
      image: poster16,
      iframeSrc: 'https://3dthis.com/share.htm?h=NjYyODAy',
    },
    {
      id: 17,
      title: 'Positive Soul vs Negative Soul',
      views: 5,
      status: 'Public',
      image: poster17, 
      iframeSrc: 'https://3dthis.com/share.htm?h=MTcwNzk2Ng',
    },
    {
      id: 18,
      title: 'Panorama',
      views: 15,
      status: 'Public',
      image: poster18,
      iframeSrc: 'https://3dthis.com/share.htm?h=LTQ3MTgxNzA',
    },
     {
      id: 19,
      title: 'AI-Dharma',
      views: 15,
      status: 'Public',
      image: poster19, 
      iframeSrc: 'https://3dthis.com/share.htm?h=LTQ5NjU1Ng',
    },
     {
      id: 20,
      title: 'Sanatan Dharma Journey',
      views: 15,
      status: 'Public',
      image: poster20, 
      iframeSrc: 'https://3dthis.com/share.htm?h=LTMwMTc3ODg',
    },
  ];

  return (
    <div className="artifacts-container">
      <h2 className="gallery-heading">AI Artifacts Gallery 🤖</h2>

      <div className="artifacts-grid">
        {artifacts.map((art) => (
          <div
            key={art.id}
            className="artifact-card"
            onClick={() => setSelectedArtifact(art)}
            style={{ cursor: 'pointer' }}
          >
            <span className={`status-badge ${art.status.toLowerCase()}`}>{art.status}</span>
            <img src={art.image} alt={art.title} className="artifact-image" />
            <div className="artifact-footer">
              <p className="artifact-title">{art.title}</p>
            </div>
          </div>
        ))}
      </div>

  {/* Iframe Popup */}
  {selectedArtifact && (
   <div className="iframe-overlay">
    <button className="close-button" onClick={() => setSelectedArtifact(null)}>✖</button>
    <iframe
      width="90%"
      height="90%"
      src={selectedArtifact.iframeSrc}
      frameBorder="0"
      allow="accelerometer; gyroscope; magnetometer; fullscreen"
      title={selectedArtifact.title}
    ></iframe>
  </div>
)}

      <Link to="/zones" className="back-button">⬅ Back to Museum Realms</Link>

    </div>
  );
}

export default AiArtifacts;
